/*=========================================================================================
  File Name: moduleNotifyState.js
  Description: Notify Module State
==========================================================================================*/


export default {
  notify: [],
  // clients: [],
  // log: [],
}
